/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Select} from "@chakra-ui/react";
import { Avatar } from "rsuite";
import VendorBarChart from "./vendorBarChart";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetVendorByID } from "redux/vendorSlice";
import { fetchAsyncGetVendorFinancialExpense } from "redux/vendorSlice";
import { Form } from "react-bootstrap";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import VendorsAddNew from "components/allForm/Vendors/vendorsAddNew";
import { GoPencil } from "react-icons/go";
import { getGstTreatment,getAccountType } from "components/allForm/Vendors/customFieldData";
import GetAddress from "components/GetAddress";
import { generateYearOptions } from "../default/components/filterOption";

const {yearOption,defaultSelected} = generateYearOptions();
const VendorOverview = ({activeTab}) => {

  const { id } = useParams();  
  const dispatch = useDispatch();
  const [vendorDetail, setVendorDetail] = useState({});

  const [revenueData,setRevenueData] = useState([0,0,0,0,0,0,0,0,0,0,0,0])
    
  const [loading, setLoading] = useState(false); // Loading state

  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  

  useEffect(()=>{
    if(currUser && currUser?.auth){

      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Vendor');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
   
  },[currUser])
  const fetchVendorDetails = async (vendorId) => {
    setLoading(true); 
    try {
      const res = await dispatch(fetchAsyncGetVendorByID(vendorId)); 
      if (res?.payload) {
        setVendorDetail(res.payload.vendor);
      }
    } catch (error) {
    } finally {
      setLoading(false); // Stop loading
    }
  };


  const getVendorFinancialYearWiseExpense = (id,financialYear)=>{
    setLoading(true); 
    dispatch(
      fetchAsyncGetVendorFinancialExpense({
        vendorId: id,
        financialYear:financialYear
        }
      )
    ).then((res) => {
      if (res.payload) {
        const data = res.payload || [];
        const amountArray = data.map((item)=> item?.totalAmount)
        setRevenueData(amountArray)
      } else {
        console.log("error")
      }
    }).finally(() => {
      setLoading(false); // Stop loading
    });

  }


  const [selectedYear, setSelectedYear] = useState(defaultSelected); 

  const getMonthsForYear = (year) => {
      const months = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"];
      const yearStart = parseInt(year.split("-")[0]); 
      const yearEnd = parseInt(year.split("-")[1]);   

      let startMonthIndex, endMonthIndex, xAxisLabel;

     
      startMonthIndex = 0; 
      endMonthIndex = 11; 
      xAxisLabel = `${year.split("-")[0]} to ${year.split("-")[1]}`;
    
      const monthRange = months.slice(startMonthIndex, endMonthIndex + 1).map((month, index) => {
          const monthYear = index < 9 ? yearStart : yearEnd; 
          return `${month}-${monthYear}`;
      });

      return { monthRange, xAxisLabel };
  };

  const { monthRange } = getMonthsForYear(selectedYear);

  useEffect(() => {
    if (id && activeTab === 'overview') {
      fetchVendorDetails(id);
      getVendorFinancialYearWiseExpense(id,selectedYear)
    }
  }, [id]); 

  useEffect(()=>{
    if (id && activeTab === 'overview') {
      getVendorFinancialYearWiseExpense(id,selectedYear)
    }
  },[selectedYear,activeTab])

  const chartOptions = {
      xaxis: {
          categories: monthRange, 
      },
  };

  const [openVendorModal, setOpenVendorModal] = useState(false);

  const handleOpenVendorModal = () => {
    setOpenVendorModal(true);
  };


  const handleCloseVendorModal = () => {
    setOpenVendorModal(false);
    fetchVendorDetails(id);
  };

  
  if (loading) {
    return (
      <SpinnerLoader/>
    );
  }


  return (
    <>
      <Box display="flex" className="mx-0 vendor_details">
        <Box className="overview_details_sidebar">
          <Box className="all-vendor mx-2">
            <Text className="all-vendor-text">{vendorDetail?.name} <button className="vendor-edit-btn mt-1" onClick={handleOpenVendorModal}><GoPencil fontWeight={600}/></button></Text>
          </Box>
          <Box display="flex" className="vendor-avtar mt-4 mx-0">
            <Avatar name="Sage Adebayo" shape="rounded" size="22" />
            <Box>

            <Text className="mx-3" fontWeight="600">
              {vendorDetail?.name}
            <Text color="#408DFB" fontSize="11px">Email: {vendorDetail?.mail} </Text>
            </Text>
            </Box>
            
          </Box>
          <Box className="acordian-box mt-3">
            <Accordion defaultIndex={[0]} allowMultiple>
              <AccordionItem borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600">Personal Details</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal px-0">
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Company Name </Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000">{vendorDetail?.name}</Text>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Contact Person </Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.salutation?.value} {vendorDetail?.cptn}</Text>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Phone</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.ld ? vendorDetail?.ld :'-'}</Text>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Mobile</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.ph ? vendorDetail?.ph : "-"}</Text>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Email</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.mail}</Text>
                  </Box>
                
                </AccordionPanel>
                
              </AccordionItem>
              <Text fontWeight="600" fontSize="13px" mt={3} mb={2}>Vendor Type</Text>
              <Box className="d-flex mt-2">

                      <Form.Check
                        type="checkbox"
                        name="isVendor"
                        label="Vendor"
                        checked={vendorDetail?.isV}
                      />
                   
                      <Form.Check
                        type="checkbox"
                        name="isConsultant"
                        className="mx-3"
                        label="Consultant"
                        checked={vendorDetail?.isC}
                      />
                      </Box>
              <AccordionItem borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600">Address</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal px-0">
                  <Box display="flex" flexDirection="column">
                        <Box flex="1" textAlign="left">
                          <Text fontWeight="600" color="#6C7184">Billing Address</Text>
                        </Box>
                    <GetAddress address={vendorDetail?.blAd} color="#6C7184" />
                    <Text color="#6C7184">{vendorDetail?.biAd?.ph ? `Phone: ${vendorDetail?.blAd?.ph || "-"}` :""}</Text>
                    <Text color="#6C7184">{vendorDetail?.blAd?.mail ? `Email: ${vendorDetail?.blAd?.mail || "-"}` :''}</Text>
                  </Box>
                 
                
                </AccordionPanel>
                <AccordionPanel className="acordian-panal px-0">
                  <Box display="flex" justifyContent="space-between" flexDirection="column">
                        <Box flex="1"  textAlign="left">
                          <Text fontWeight="600" color="#6C7184">Shipping Address</Text>
                        </Box>
                        <GetAddress address={vendorDetail?.spAd} color="#6C7184" />

                    <Text color="#6C7184">{vendorDetail?.spAd?.ph ? `Phone: ${vendorDetail?.spAd?.ph || "-"}` :""}</Text>
                    <Text color="#6C7184">{vendorDetail?.spAd?.mail ? `Email: ${vendorDetail?.spAd?.mail || "-"}` :''}</Text>
                  </Box>
                 
                
                </AccordionPanel>
                
              </AccordionItem>
              <AccordionItem borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600">Tax Details</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal px-0">
                  
                <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">GST Number</Text>
                    <Box display="flex" flexDirection="column">

                    {vendorDetail?.gsts && vendorDetail?.gsts?.length ?
                    vendorDetail?.gsts.map((item,i)=>{
                      return(
                        <>
                        <Text className="mt-1 text2" fontWeight={500} color="#000000">{i+1}. {item?.gstNo}</Text>
                        <Text className="mt-1 mx-3 text2" fontWeight={500} color="#000000">{item?.pos ? item?.pos : ""}</Text>
                        </>

                      )
                    })
                    :
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.gstNo}</Text>
                    }
                    </Box>
                  </Box>

                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">PAN Number</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.pnNo}</Text>
                  </Box>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem borderTop="none">
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left">
                      <Text fontWeight="600">Other Details</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel className="acordian-panal px-0">
                  
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Customer Type</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.typ}</Text>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">GST Treatment</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{getGstTreatment(vendorDetail?.gstTrt) || ""}</Text>
                  </Box>
                 
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Text color="#6C7184">Tax Preference</Text>
                    <Text className="mt-0 text2" fontWeight={500} color="#000000">{vendorDetail?.txPrf}</Text>
                  </Box>
                  
                </AccordionPanel>
              </AccordionItem>


              <Text fontWeight="600" fontSize="14px" mt={8} mb={2}>Vendor Bank Details</Text>
              {vendorDetail?.bnkDtl && vendorDetail?.bnkDtl?.length > 0 && vendorDetail?.bnkDtl?.map((item,i)=>{
                return (
                  <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box flex="1" textAlign="left">
                        <Text fontWeight="600">{item?.bnk}  Detail</Text>
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel className="acordian-panal px-0">
                    
                    <Box display="flex" flexDirection="column" mb={3}>
                      
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Account Holder Name </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.hol ? item?.hol : vendorDetail?.name}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Account Number </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.acNo}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">IFSC Code </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.ifc}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Account Type </Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{getAccountType(item?.typ)}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">Bank Name</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bnk}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">SWIFT Code</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.swt}</Text>
                        </Box>
                        <Box display="flex"   justifyContent="space-between" mb={3}>
                          <Text color="#6C7184">Branch Name</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bch}</Text>
                        </Box>
                        <Box flex="1" mb={3} textAlign="left">
                          <Text fontWeight="600" color="#6C7184">Bank Address</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">City</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bAd?.ct}</Text>
                        </Box>
                        <Box display="flex" justifyContent="space-between" mb={2}>
                          <Text color="#6C7184">State</Text>
                          <Text className="mt-0 text2" fontWeight={500} color="#000000">{item?.bAd?.st}</Text>
                        </Box>
                    
                    </Box>
  
                   
                    
                  </AccordionPanel>
                </AccordionItem>
                )
              })}
             
             
            </Accordion>
          </Box>
        </Box>

        <Box className="vendor_details_main mt-5 mx-4">
        <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Text>
                            <strong>Amount</strong> - Total Payments Made to Vendors for This Financial Year
                        </Text>

                        <Select
                        className="graph-year-select"
                            width="auto"
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                        >
                            {yearOption.map((year) => (
                                <option key={year.value} value={year.value}>
                                    {year.label}
                                </option>
                            ))}
                        </Select>
                    </Box>
              <Box mt={5} height={400}>
                <VendorBarChart chartData={[{name: "Revenue",data: revenueData,  }]} chartOptions={chartOptions} />
              </Box>
        </Box>
      </Box>
      {openVendorModal && (
        <VendorsAddNew
          openModal={openVendorModal}
          closeModal={handleCloseVendorModal}
          isEdit={openVendorModal}
          editData={vendorDetail}
          role={role}

        />
      )}
    </>
  );
};

export default VendorOverview;
